/**
 * Señas (backend.md §7.1) and the one-tap chat phrases (frontend.md §4.3).
 *
 * Both are Mus vocabulary and stay Spanish in every locale — the code is the
 * i18n key into the shared `mus` namespace, never an English string.
 */
import { z } from 'zod';
export const SENA_CODES = [
    'ciega',
    'dosReyes',
    'dosAses',
    'mediasReyes',
    'mediasAses',
    'duples',
    'treintaYUna',
    'treinta',
    'juegoFuerte',
];
export const senaCodeSchema = z.enum(SENA_CODES);
/**
 * The one-tap phrases, in the order the phrase bar renders them. Each id is a
 * key under the `mus` namespace whose value is the Spanish line — "¡Órdago a la
 * grande!", "¡Envido dos más!", "Ahí queda eso", "A pares y a juego" — the same
 * text in both locales, because these are Mus table talk and are never
 * translated (decisions.md).
 */
export const QUICK_PHRASE_IDS = [
    'ordagoALaGrande',
    'envidoDosMas',
    'ahiQuedaEso',
    'aParesYaJuego',
    'tengoJuego',
    'noHayMus',
    'pasoPaso',
    'buenaMano',
    'vayaTela',
    'suerte',
];
export const quickPhraseIdSchema = z.enum(QUICK_PHRASE_IDS);
/**
 * Table chat limits (backend.md §7.1). Shared so the composer can grey its own
 * send button on the same numbers the room enforces — the server is still the
 * authority and answers `CHAT_RATE_LIMIT`.
 */
export const CHAT_LIMITS = {
    maxLength: 200,
    /** Free text: 1 message per 1.5 s, 10 per 30 s. */
    minIntervalMs: 1_500,
    burst: 10,
    burstWindowMs: 30_000,
    /** Quick phrases have their own, looser budget. */
    quickMinIntervalMs: 2_000,
};
/** The lobby's chat is slower still: one line every three seconds (§3.8). */
export const LOBBY_CHAT_MIN_INTERVAL_MS = 3_000;
/** Untruthful señas tolerated in a match before the seat is muted (§3.4). */
export const SENA_LIE_LIMIT = 3;
/** One seña per seat per lance (§3.4). */
export const SENA_PER_LANCE_LIMIT = 1;
//# sourceMappingURL=senas.js.map